// Which sidebar caption each nav item belongs under.
//
// These three groups used to be index ranges over one array —
// slice(0, 5) / slice(5, 8) / slice(8) — so adding or removing a single entry
// silently moved every boundary below it. That coupling has now misfired twice:
// 026 D7 removed "Schedule Lesson" and had to renumber both later ranges, and
// restoring "Lessons" (D23) renumbered them back. Worse, the removal orphaned
// Lesson Management for five days, because the numbers say nothing about what
// they contain and nothing fails when they are wrong.
//
// Each item now names its own section, and the numbers are gone.
//
// Spec 044 D1: the six groups are named after what staff are doing, not after
// what the database holds. Each entry names its own section; the fallback for
// an unknown one is the FIRST group, Home — the one every role sees — because
// after 044 the last group is Admin, and an orphan hidden from moderators is the
// exact failure this file exists to prevent.
export const NAV_SECTIONS = [
  { key: "home", caption: "Home" },
  { key: "support", caption: "Support" },
  { key: "people", caption: "People" },
  { key: "money", caption: "Money" },
  { key: "growth", caption: "Growth" },
  { key: "admin", caption: "Admin" },
];

const KEYS = NAV_SECTIONS.map((s) => s.key);
const FALLBACK = KEYS[0];

/**
 * Group menu items by their `section`, preserving order within each group.
 *
 * An item with a missing or unrecognised section lands in the first group rather
 * than being dropped. That fallback is the whole point: a filter that silently
 * matches nothing would hide a page exactly the way the index ranges did, and a
 * throw would take the sidebar down over a typo. It is loud in the console and
 * visible on the screen.
 */
export function groupBySection(items) {
  const groups = Object.fromEntries(KEYS.map((k) => [k, []]));

  (items || []).forEach((item) => {
    const known = KEYS.includes(item.section);
    if (!known) {
      console.warn(
        `Nav item "${item.text}" has section "${item.section}", which is not one of ${KEYS.join(", ")}. Showing it under "${FALLBACK}".`
      );
    }
    groups[known ? item.section : FALLBACK].push(item);
  });

  return groups;
}
